/**
 * The company's own registration facts, in one place.
 *
 * These strings are printed on documents that leave the building — the parent's
 * Official Receipt and the tutor's self-billing statement — and they are also
 * what a parent types into PayNow and what Google reads out of the homepage
 * JSON-LD. A UEN that disagreed with itself across those surfaces would be a
 * real-world problem (a mistyped PayNow UEN sends money nowhere), so the number
 * is stated once here and imported everywhere else.
 *
 * Update only when the company registration itself changes.
 *
 * Note the two legal-name spellings that exist on purpose: documents use the
 * punctuated `DeepThink Pte. Ltd.` that matches ACRA, while the marketing
 * JSON-LD carries its own unpunctuated spelling for NAP consistency with the
 * business listings already published. Only the UEN is shared.
 */

/** ACRA-registered legal name, as printed on receipts and statements. */
export const COMPANY_LEGAL_NAME = 'DeepThink Pte. Ltd.';

/** Unique Entity Number. Also the PayNow payee identifier. */
export const COMPANY_UEN = '202515940H';

/** Prefix of every receipt number: `DT-20260828-001`. */
export const RECEIPT_NUMBER_PREFIX = 'DT';

/** ISO 4217 code for every amount these documents state. */
export const RECEIPT_CURRENCY = 'SGD';
